import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requireDealership = false, requireVendor = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireDealership && user.user_type !== 'DealershipUser') {
    return <Navigate to="/" replace />;
  }

  if (requireVendor && user.user_type !== 'VendorUser') {
    return <Navigate to="/" replace />;
  }

  return children;
};